Pixlee.module('Entities', function(Entities, App, Backbone, Marionette, $) {
    var _this = this,
        API;

    API = {
        setRecipe: function(options) {
            return new Entities.Recipe(options);
        }
    };

    Entities.Recipe = Entities.Model.extend();

    App.reqres.setHandler('set:recipe', function(displaySettings) {
        return API.setRecipe(displaySettings);
    });

});
